module.exports = __webpack_public_path__ + "img/avator_big.999b50db.png";